import {FBTrackingEvent} from "./FBTrackingEvent";

export const AdjustLevelEventsMap = new Map<number, FBTrackingEvent>([
           [1, FBTrackingEvent.LEVEL_01_COMPLETE],
           [2, FBTrackingEvent.LEVEL_02_COMPLETE],
           [3, FBTrackingEvent.LEVEL_03_COMPLETE],
           [4, FBTrackingEvent.LEVEL_04_COMPLETE],
           [5, FBTrackingEvent.LEVEL_05_COMPLETE],
           [6, FBTrackingEvent.LEVEL_06_COMPLETE],
           [7, FBTrackingEvent.LEVEL_07_COMPLETE],
           [8, FBTrackingEvent.LEVEL_08_COMPLETE],
           [9, FBTrackingEvent.LEVEL_09_COMPLETE],
           [10, FBTrackingEvent.LEVEL_10_COMPLETE],
           [20, FBTrackingEvent.LEVEL_20_COMPLETE],
           [30, FBTrackingEvent.LEVEL_30_COMPLETE],
           [40, FBTrackingEvent.LEVEL_40_COMPLETE],
           [50, FBTrackingEvent.LEVEL_50_COMPLETE],
           [60, FBTrackingEvent.LEVEL_60_COMPLETE],
           [70, FBTrackingEvent.LEVEL_70_COMPLETE],
           [80, FBTrackingEvent.LEVEL_80_COMPLETE],
           [90, FBTrackingEvent.LEVEL_90_COMPLETE],
           [100, FBTrackingEvent.LEVEL_100_COMPLETE],
           [200, FBTrackingEvent.LEVEL_200_COMPLETE],
           [300, FBTrackingEvent.LEVEL_300_COMPLETE],
           [400, FBTrackingEvent.LEVEL_400_COMPLETE],
           [500, FBTrackingEvent.LEVEL_500_COMPLETE],
           [600, FBTrackingEvent.LEVEL_600_COMPLETE],
           [700, FBTrackingEvent.LEVEL_700_COMPLETE],
           [800, FBTrackingEvent.LEVEL_800_COMPLETE],
           [900, FBTrackingEvent.LEVEL_900_COMPLETE],
           [1000, FBTrackingEvent.LEVEL_1000_COMPLETE],
       ]);

export const AdjustTokens = new Map<FBTrackingEvent, string>([
    [FBTrackingEvent.LEVEL_01_COMPLETE, 'mfha0i'],
    [FBTrackingEvent.LEVEL_02_COMPLETE, 'cpetaa'],
    [FBTrackingEvent.LEVEL_03_COMPLETE, 'mdxjjz'],
    [FBTrackingEvent.LEVEL_04_COMPLETE, '4rcr5q'],
    [FBTrackingEvent.LEVEL_05_COMPLETE, '3ffy1s'],
    [FBTrackingEvent.LEVEL_06_COMPLETE, 'qul8re'],
    [FBTrackingEvent.LEVEL_07_COMPLETE, '9bpwn2'],
    [FBTrackingEvent.LEVEL_08_COMPLETE, '7buojj'],
    [FBTrackingEvent.LEVEL_09_COMPLETE, 'y47n3w'],
    [FBTrackingEvent.LEVEL_10_COMPLETE, '7wslht'],
    [FBTrackingEvent.LEVEL_20_COMPLETE, 'oy8aod'],
    [FBTrackingEvent.LEVEL_30_COMPLETE, '71xsom'],
    [FBTrackingEvent.LEVEL_40_COMPLETE, '5vl0sp'],
    [FBTrackingEvent.LEVEL_50_COMPLETE, '5sqg4b'],
    [FBTrackingEvent.LEVEL_60_COMPLETE, 'xv3sn5'],
    [FBTrackingEvent.LEVEL_70_COMPLETE, 'ooiciv'],
    [FBTrackingEvent.LEVEL_80_COMPLETE, 'yujk66'],
    [FBTrackingEvent.LEVEL_90_COMPLETE, 'tv69rl'],
    [FBTrackingEvent.LEVEL_100_COMPLETE, '6n0ve3'],
    [FBTrackingEvent.LEVEL_200_COMPLETE, '9q8s8e'],
    [FBTrackingEvent.LEVEL_300_COMPLETE, 'e5qeo7'],
    [FBTrackingEvent.LEVEL_400_COMPLETE, 'b2ols7'],
    [FBTrackingEvent.LEVEL_500_COMPLETE, 'lse7pq'],
    [FBTrackingEvent.LEVEL_600_COMPLETE, 'ibi4jd'],
    [FBTrackingEvent.LEVEL_700_COMPLETE, 'gdii7r'],
    [FBTrackingEvent.LEVEL_800_COMPLETE, '4q1kug'],
    [FBTrackingEvent.LEVEL_900_COMPLETE, '7vc4ee'],
    [FBTrackingEvent.LEVEL_1000_COMPLETE, '5oxg0g'],

    [FBTrackingEvent.ONE_MILLION_COINS, '9wcrkn'],
    [FBTrackingEvent.TEN_THOUSAND_COINS, '69riuf'],
    [FBTrackingEvent.ONE_HUNDRED_TWENTY_THOUSAND_COINS, 'yxv8w7'],
    [FBTrackingEvent.SIXTY_THOUSAND_COINS, 'vs5tox'],
    [FBTrackingEvent.JOKER_DEAL_v2, 'lj5mal'],
    [FBTrackingEvent.SPECIAL_OFFER, '10mgcy'],
    [FBTrackingEvent.STARTER_PACK_v3, 'n1yqsw'],
    [FBTrackingEvent.SUNDAY_OFFER_V2, 'd53ayq'],
    [FBTrackingEvent.SUNDAY_OFFER, 'r1tusm'],

    [FBTrackingEvent.AD_WHALES_24h_5_ADS, 'yqaj96'],
    [FBTrackingEvent.AD_WHALES_24h_10_ADS, '20xago'],
    [FBTrackingEvent.HEAVY_USERS_24h_10_lvl_complete, '6vfxx0'],
    [FBTrackingEvent.HEAVY_USERS_24h_20_lvl_complete, 'qatz9i'],
]);
